module.exports = __webpack_public_path__ + "static/media/cardCircle.c2691ed8.svg";